import { useEffect } from "react";

import EcommerceItem from "@/types/gtm/EcommerceItem";
import { ConfirmationGtmEvent } from "@/types/gtm/QuoteReviewEvent";

import { defaultConfirmationEventData } from "./default-confirmation-event-data";

export interface ExtendedWindow extends Window {
  dataLayer?: ConfirmationGtmEvent[];
}

type ConfirmationPageLoadProps = {
  confirmationData: Partial<ConfirmationGtmEvent | null>;
  policyItems: EcommerceItem[] | null;
  isReady: boolean;
};

const useGtmConfirmationOption = (props: ConfirmationPageLoadProps) => {
  delete defaultConfirmationEventData.golf_cover;
  delete defaultConfirmationEventData.car_hire_excess_waiver;
  const { confirmationData, policyItems, isReady } = props;

  useEffect(() => {
    const triggerPageLoadEvent = () => {
      if (confirmationData !== null && policyItems !== null) {
        const extendedWindow = window as ExtendedWindow;
        extendedWindow.dataLayer = extendedWindow.dataLayer ?? [];

        const eventData = {
          ...defaultConfirmationEventData,
          ...confirmationData,
        };
        if (eventData.ecommerce) eventData.ecommerce.items = policyItems;

        extendedWindow.dataLayer.push({
          ...eventData,
        });
      }
    };
    if (isReady) triggerPageLoadEvent();
    return () => {
      // Cleanup code if needed
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady]);
};

export default useGtmConfirmationOption;
